import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
// import { ConfigResolverService } from './resolvers/configResolverService';
import { ShippingComponent } from './shipping/shipping.component';
import { DailyDoseComponent } from './daily-dose/daily-dose.component';
import { CancellationPolicyComponent } from './cancellation-policy/cancellation-policy.component';


const routes: Routes = [
// new routes
  {
    path: '',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
  },
  {path:'daily-dose',component:DailyDoseComponent},
  {path:'daily-dose/:datetime-value/:pdf-id',component:DailyDoseComponent},
  {
    path: 'redirect',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./redirect-page/redirect-page.module').then(m => m.RedirectPageModule)
  },
  {
    path: 'sign-in',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'sign-up',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
  },
  {
    path: 'forgot-password',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule)
  },
  {
    path: 'quizes',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./quizes/quizes.module').then(m => m.QuizesModule)
  },
  {
    path: 'live-test',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./scholarship/scholarship.module').then(m => m.ScholarshipModule)
  },
  {
    path: 'current-affairs',
    loadChildren: () => import('./current-affairs/current-affairs.module').then(m => m.CurrentAffairsModule)
  },
  {
    path: 'master-login/:id',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./master-login/master-login.module').then(m => m.MasterLoginModule)
  },
  {
    path: 'mobile',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./mobile/mobile.module').then(m => m.MobileModule)
  },
  {
    path: 'user',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./user/user.module').then(m => m.UserModule)
  },
  // {
  //   path: 'privacy-policy',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule)
  // },
  // {
  //   path: 'terms-conditions',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./terms-conditions/terms-conditions.module').then(m => m.TermsConditionsModule)
  // },
  // {path:'shipping',component:ShippingComponent},
  // {path:'cancellation-policy',component:CancellationPolicyComponent},
  // {
  //   path: 'gallery',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./gallery/gallery.module').then(m => m.GalleryModule)
  // },
  // {
  //   path: 'courses',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./courses/courses.module').then(m => m.CoursesModule)
  // },
  // {
  //   path: 'publications',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./publications/publications.module').then(m => m.PublicationsModule)
  // },
  // {
  //   path: 'about-us',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./aboutus/aboutus.module').then(m => m.AboutusModule)
  // },
  // {
  //   path: 'blog',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./blog/blog.module').then(m => m.BlogModule)
  // },
  // {
  //   path: 'contact-us',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./contactus/contactus.module').then(m => m.ContactusModule)
  // },
  // {
  //   path: 'online-test-series',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./testseries/testseries.module').then(m => m.TestseriesModule)
  // },
  // {
  //   path: ':cat-ts/online-test-series',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./testseries/testseries.module').then(m => m.TestseriesModule)
  // },

  // {
  //   path: 'practice',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./practice/practice.module').then(m => m.PracticeModule)
  // },
  // {
  //   path: 'previous-paper',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./previous-paper/previous-paper.module').then(m => m.PreviousPaperModule)
  // },
  // {
  //   path: 'free-mock',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./free-mock/free-mock.module').then(m => m.FreeMockModule)
  // },
  // {
  //   path: 'study-material',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./study-material/study-material.module').then(m => m.StudyMaterialModule)
  // },
  // {
  //   path: 'study',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./study/study.module').then(m => m.StudyModule)
  // },
  // {
  //   path: 'study-detail/:id',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./study-detail/study-detail.module').then(m => m.StudyDetailModule)
  // },
  // {
  //   path: 'refund-policy',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./return-refund/return-refund.module').then(m => m.ReturnRefundModule)
  // },
  // {
  //   path: 'blog-detail/:id',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./blog-detail/blog-detail.module').then(m => m.BlogDetailModule)
  // },
  // {
  //   path: 'cart/:id',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./cart/cart.module').then(m => m.CartModule)
  // },
  // {
  //   path: 'success',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./success/success.module').then(m => m.SuccessModule)
  // },
  // {
  //   path: 'failed',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./failed/failed.module').then(m => m.FailedModule)
  // },
  // {
  //   path: 'careers',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./careers/career.module').then(m => m.CareerModule)
  // },
  // {
  //   path: 'all-test',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./all-series/all-series.module').then(m => m.AllSeriesModule)
  // },
  // {
  //   path: 'discuss',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./discuss/discuss.module').then(m => m.DiscussModule)
  // },
  // {
  //   path: 'forum',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./forum/forum.module').then(m => m.ForumModule)
  // },
  // {
  //   path: 'forum-detail/:id',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./forum-detail/forum-detail.module').then(m => m.ForumDetailModule)
  // },
  // {
  //   path: 'plans',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./offers/offers.module').then(m => m.OffersModule)
  // },
  // {
  //   path: 'selections',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./selection/selection.module').then(m => m.SelectionModule)
  // },
  // {
  //   path: 'videos',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./videos/videos.module').then(m => m.VideosModule)
  // },
 
  // {
  //   path: 'notes',
  //   loadChildren: () => import('./pdf-notes/pdf-notes.module').then(m => m.PdfNotesModule)
  // },
  // {
  //   path: 'affiliate',
  //  // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./affiliate/affiliate.module').then(m => m.AffiliateModule)
  // },
  // {
  //   path: 'affiliates',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./affiliates/affiliates.module').then(m => m.AffiliatesModule)
  // },

  // {
  //   path: 'live-test',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./scholarship/scholarship.module').then(m => m.ScholarshipModule)
  // },
  {
    path: 'ebooks',
    // canLoad: [ConfigResolverService ],
    loadChildren: () => import('./ebooks/ebooks.module').then(m => m.EbooksModule)
  },
  // {
  //   path: 'exams',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./exams/exams.module').then(m => m.ExamsModule)
  // },
  // {
  //   path: 'recruitment-exams',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./exams-type/exams-type.module').then(m => m.ExamsTypeModule)
  // },
  // {
  //   path: 'entrance-exams',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./exams-type/exams-type.module').then(m => m.ExamsTypeModule)
  // },
  // {
  //   path: 'exam',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./exam-page/exam-page.module').then(m => m.ExamPageModule)
  // },
  // {
  //   path: ':online-sub-test-cat',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./test-series-all-series/test-series-all.module').then(m => m.TestSeriesAllModule)
  // },

  // {path:'test-series/:cat', redirectTo:'/online-test-series',pathMatch:'full' },
  // {
  //   path: ':examCat/:examSubCat',
  //   // canLoad: [ConfigResolverService ],
  //   loadChildren: () => import('./exams-page/exams-page.module').then(m => m.ExamsPageModule)
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
